/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const personSchema = z.object({
  id: z.number(),
  slug: z.string(),
  name: z.string(),
  sortName: z.string().nullable().optional(),
  bio: z.string().nullable().optional(),
  birthday: z.string().nullable().optional(),
  deathday: z.string().nullable().optional(),
  birthplace: z.string().nullable().optional(),
  gender: z.string().nullable().optional(),
  knownForDepartment: z.string().nullable().optional(),
  avatarPath: z.string().nullable().optional(),
  tmdbId: z.number().nullable().optional(),
  imdbId: z.string().nullable().optional(),
  playableChallengesCount: z.number(),
  sortOrder: z.number(),
  createdAt: z.number(),
  updatedAt: z.number(),
});

export type IPerson = z.infer<typeof personSchema>;
